export default __webpack_public_path__ + "static/media/gundam-robot.c24f951d.webp";